import styled from 'styled-components';
import { WarningType } from './WarningMessage.component';

export const FeedbackArea = styled.div`
  position: absolute;
  line-height: 14px;
  bottom: -16px;
  display: flex;
  align-items: center;
`;

export const FeedbackMessage = styled.p<{ $type: WarningType }>`
  font-size: 10px;
  color: ${({ $type, theme }) => ($type === 'error' ? theme.colors.warning : '#FF991C')};
`;
